Bingo.PreviewGallery = {};

/**
 * Initialize swiper if not already initialized.
 * @param id string
 */
Bingo.PreviewGallery.init = (id) => {
    Bingo.ImageController.init(id);

    const elem = document.getElementById(id);
    const slides = $(`#${id} .swiper-slide`).length;

    // Skip if element with given id does not exists or if swiper already initialized
    if (elem === null || elem.swiper !== undefined) {
        return;
    }

    const selector = `#${id}`;
    const isInSwiper = $(selector).parents('.swiper-slide').length;

    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    const lazyOptions = {
        loadPrevNext: true,
        elementClass: isInSwiper ? 'swiper-not-first-slide-lazy' : 'swiper-lazy',
    };

    new Swiper(selector, {
        preloadImages: false,
        allowTouchMove: false,
        lazy: !isIE11 ? lazyOptions : false,
        slidesPerView: 1,
        navigation: {
            nextEl: `${selector} .js-preview__carouselArrow--toRight`,
            prevEl: `${selector} .js-preview__carouselArrow--toLeft`,
        },
        loop: false,
        touchRatio: slides > 1 ? 1 : 0,
        observer: true,
        observeParents: true,
    });
};

/**
 * Initialize all swipers that are not already initialized.
 * @param selector string
 */
Bingo.PreviewGallery.initMultiple = (selector) => {
    $(selector).each(function () {
        Bingo.PreviewGallery.init($(this).attr('id'));
    });
};

/**
 * Extension to nette.ajax.js
 */
(function ($) {
    $.nette.ext('preview-gallery', {
        init() {
            this.ext('snippets', true).after($.proxy(($el) => {
                // Initialize swipers in snippet
                $($el).find('.js-preview__carouselItems').each(function () {
                    Bingo.PreviewGallery.init($(this).attr('id'));
                });
            }, this));

            // Initialize when page is loaded
            $('.js-preview__carouselItems').each(function () {
                Bingo.PreviewGallery.init($(this).attr('id'));
            });
        },
    });
}(jQuery));
